// react
import React, { Fragment, useContext } from 'react';
import { FormattedMessage } from 'react-intl';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link , useHistory , useLocation } from 'react-router-dom';

// application
import { ArrowRoundedLeft6x9Svg } from '../../svg';
import { getCategoryParents, url } from '../../services/utils';
import CategoriesContext from '../../contexts/CategoriesContext';

function FilterCategory(props) {
    const { data } = props;
    const lang = JSON.parse(localStorage.getItem('state'))?.locale
    const { getCateogryLanguage } = useContext(CategoriesContext)

    const history = useHistory();
    const location = useLocation();

    const handleClick = (category) => {
        history.push(`${category}${window.location.search}`);
      };

    console.log(window.location.search)

    const categoriesList = data.items.map((category) => {
        const itemClasses = classNames('filter-categories__item', {
            'filter-categories__item--current': data.value === category.slug,
        });

        return (
            <Fragment key={category.id}>
                {getCategoryParents(category).map((parent) => (
                    <li key={parent.id} className="filter-categories__item filter-categories__item--parent">
                        <ArrowRoundedLeft6x9Svg className="filter-categories__arrow" />
                        <span onClick={() => handleClick(url.category(parent))}>{getCateogryLanguage(lang, parent.name)}</span>
                    </li>
                ))}
                <li className={itemClasses}>
                    <span onClick={() => handleClick(url.category(category))}>{getCateogryLanguage(lang ,category.name)}</span>
                </li>
                {category.children && category.children.map((child) => (
                    <li key={child.id} className="filter-categories__item filter-categories__item--child">
                        <span onClick={() => handleClick(url.category(child))}>{getCateogryLanguage(lang ,child.name)}</span>
                    </li>
                ))}
            </Fragment>
        );
    });

    if (data.value) {
        categoriesList.unshift(
            <li key="[shop]" className="filter-categories__item filter-categories__item--parent">
                <ArrowRoundedLeft6x9Svg className="filter-categories__arrow" />
                <span onClick={() => handleClick('/shop/catalog')}><FormattedMessage id="filter_categoryall" defaultMessage="All Products" /></span>
            </li>,
        );
    }

    return (
        <div className="filter-categories">
            <ul className="filter-categories__list">
                {categoriesList}
            </ul>
        </div>
    );
}

FilterCategory.propTypes = {
    /**
     * Filter object.
     */
    data: PropTypes.object,
};

export default FilterCategory;
